import { ReactNode, useMemo } from 'react';
import PauseMonitoringContext from './PauseMonitoringContext';

interface IProps {
  children: ReactNode;
  onRequestResumeMonitoring: () => void;
}

const PauseMonitoringContextProvider = ({ children, onRequestResumeMonitoring }: IProps) => {
  const value = useMemo(
    () => ({
      onRequestResumeMonitoring,
    }),
    [onRequestResumeMonitoring],
  );

  return (
    <PauseMonitoringContext.Provider value={value}>{children}</PauseMonitoringContext.Provider>
  );
};

export default PauseMonitoringContextProvider;
